import Vue from 'vue'
import App from './app.vue'
import router from '@router'
import store from '@state/store'

import './main.globals.js'
import './main.filters.js'
import './vee-validate.js'

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
